Auth = require 'db/auth'
LocalStorageModel = require 'view-models/internal/local-storage-model'
_ = require 'underscore'

module.exports = new class extends LocalStorageModel

  constructor: ->
    super()
    @set({ id: "sidebarState-#{ Auth.myId() }" })
    @fetch()

  default: -> {
    pinBoardsListSidebar: false
    showBoardsListSidebar: false
    idRecentBoards: []
    collapsedDrawerSections: []
  }

  syncedKeys: [
    'idRecentBoards'
    'collapsedDrawerSections'
    'pinBoardsListSidebar'
    'showBoardsListSidebar'
  ]

  getPinSidebar: ->
    @get('pinBoardsListSidebar')

  showPinSidebar: ->
    @save('pinBoardsListSidebar', true)

  hidePinSidebar: ->
    @save('pinBoardsListSidebar', false)


  getShowSidebar: ->
    @get('showBoardsListSidebar')

  showSidebar: ->
    @save('showBoardsListSidebar', true)

  hideSidebar: ->
    @save('showBoardsListSidebar', false)

  hideUnpinnedSidebar: ->
    if @getShowSidebar() and !@getPinSidebar()
      @hideSidebar()

  getRecentBoards: ->
    @get('idRecentBoards')

  pullBoard: (idBoard) ->
    viewArray = _.clone @getRecentBoards()
    while (index = _.indexOf viewArray, idBoard) > -1
      viewArray.splice index, 1

    @save 'idRecentBoards', viewArray

  pushBoard: (idBoard) ->
    viewArray = _.clone @getRecentBoards()

    if _.contains(viewArray, idBoard)
      viewArray = _.without(viewArray, idBoard)

    viewArray.unshift(idBoard)

    # we only show seven recent boards, but we exclude starred boards.
    # we store extra for when you star and unstar boards.
    viewArray = viewArray.slice(0, 16)

    @save('idRecentBoards', viewArray)

  getCollapsedSections: ->
    @get('collapsedDrawerSections') ? @default().collapsedDrawerSections

  isCollapsed: (id) ->
    _.contains @getCollapsedSections(), id

  collapseSection: (id) ->
    @addToSet('collapsedDrawerSections', id)

  expandSection: (id) ->
    @pull('collapsedDrawerSections', id)



// WEBPACK FOOTER //
// ./app/scripts/view-models/sidebar-state.coffee